var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"md-badge--component"},[(_vm.count != 0)?_c('span',{staticClass:"md-badge"},[_vm._v(_vm._s(_vm.count))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }